<template>
  <div>
    <div class="tag">
      <div>{{ tag }}</div>
      <i @click="removeTag" class="fas fa-times-circle delete-button"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tags",

  props: {
    tag: {
      type: String,
      default: "noprefix",
    },
  },

  methods: {
    removeTag() {
      this.$emit("removed-tag", this.tag);
    },
  },
};
</script>

<style scoped></style>
